<template>
  <div class="p-0 mb-50 pt-10">
    <div class="mt-30 container-style mb-30">
      <div class="p-20 activity-form">
        <div class="th-notification-settings-main-container">
          <NotificationModel @onAddNotification="onAddNotification" @onEditNotification="onEditNotification" @deleteNotification="onDeleteNotification" :activityName="getActivityName" :allNotifications="allNotifications" />
          <AddNotificationModel v-if="isNotification" :activityStepList="activityStepList" :isNotification="isNotification" :studyTeam="studyTeam" :researchSites="researchSites" :siteTeamList="siteTeamList" :notificationTypes="notificationTypes" @onCloseNotification="onClose" @onSaveNotification="onSaveNotification" :notificationPayload="notificationPayload" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import NotificationModel from "./notification-model";
import AddNotificationModel from "./add-notification-model";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";

export default {
  data() {
    return {
      formData: [],
      siteFacing: this.$route.query.siteFacing,
      formId: this.$route.params.formId,
      studyId: this.$route.params.studyId,
      activityStepList: [],
      studyTeam: [],
      researchSites: [],
      allNotifications: [],
      isNotification: false,
      selectedNotification: "default",
      isEmail: true,
      isSMS: true,
      notificationTypes: {
        NO_ANSWER: "If no answer is provided",
        ANY_ANSWER: "If any answer is provided",
        SPECIFIC_ANSWER: "If a specific answer is provided",
        THRESHOLD: "If value is above/below set threshold"
      },
      siteTeamList: [],
      notificationPayload: {
        questionId: "default",
        type: "default",
        answer: "default",
        thresholdMin: "",
        thresholdMax: "",
        contacts: []
      },
      researchSitesDetails: null,
      isEditMode: false,
      currentQuestionId: null
    };
  },
  components: {
    NotificationModel,
    AddNotificationModel
  },
  computed: {
    getActivityName() {
      return this.formData && this.formData.name && this.formData.name.trim();
    }
  },
  mounted() {
    Promise.all([this.getActivityFormDetails(), this.getStudyTeam(), this.getAllNotification(), this.getSiteTeamMembers()]);
  },
  methods: {
    getSiteTeamMembers() {
      this.$api.getSiteTeamMembers(this.studyId, "", "siteTeam", true).then(
        response => {
          const resp = response.body;
          this.siteTeamList = resp;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting Site Team Members.");
        }
      );
    },
    getAllNotification() {
      if (this.siteFacing == "true" || this.siteFacing == true) {
        this.$api.getEDCNotificationFactV2(this.studyId, this.formId).then(
          response => {
            const notificationRes = response.body;
            if (notificationRes) {
              this.allNotifications = _.sortBy(notificationRes, [
                function(notification) {
                  return notification.stepName.toLowerCase().trim();
                }
              ]);
            }
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications.");
          }
        );
      } else if (this.siteFacing == "false" || this.siteFacing == false) {
        this.surveyId = this.formId;
        this.$api.getParticipantResource(this.surveyId, this.studyId).then(
          response => {
            const notificationRes = response.body.questions;

            if (notificationRes) {
              this.allNotifications = notificationRes
                .filter(function(notification) {
                  if (notification.hasOwnProperty("notifications")) {
                    if (notification.notifications) {
                      return notification.notifications[0].stepName != "";
                    }
                  }
                })
                .map(function(notification) {
                  return notification.notifications[0];
                });
            }
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications.");
          }
        );
      }
    },
    onClose() {
      this.notificationPayload = {
        questionId: "default",
        type: "default",
        answer: "default",
        thresholdMin: "",
        thresholdMax: "",
        contacts: [
          {
            id: "",
            isEmail: "",
            isMobile: ""
          }
        ]
      };
      this.isNotification = false;
    },
    getStudyTeam() {
      this.$api.getStudyTeamFact(this.studyId).then(
        response => {
          this.studyTeam = response.body;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the study team details.");
        }
      );
    },
    getActivityFormDetails() {
      if (this.siteFacing == "true" || this.siteFacing == true) {
        this.$api.getActivityFormDataV3(this.formId, this.studyId).then(
          response => {
            this.formData = response.body;
            if (this.formData.activity.questions) {
              for (let i = 0, seq = 1; i < this.formData.activity.questions.length; i++) {
                if (this.formData.activity.questions[i].type != "Section") {
                  this.formData.activity.questions[i].stepSequence = seq++;
                }
              }
              this.formData &&
                this.formData.activity.questions.filter(step => {
                  if (step.type != "SurveyInstruction" && step.type != "SurveyCompletion" && step.type != "Section") {
                    this.activityStepList.push(step);
                  }
                });
            }
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications.");
          }
        );
      } else if (this.siteFacing == "false" || this.siteFacing == false) {
        this.surveyId = this.formId;
        this.$api.getParticipantResource(this.surveyId, this.studyId).then(
          response => {
            this.formData = response.body;
            if (this.formData.questions) {
              for (let i = 0, seq = 1; i < this.formData.questions.length; i++) {
                if (this.formData.questions[i].type != "Section") {
                  this.formData.questions[i].stepSequence = seq++;
                }
              }
              this.formData &&
                this.formData.questions.filter(step => {
                  if (step.type != "SurveyInstruction" && step.type != "SurveyCompletion" && step.type != "Section") {
                    this.activityStepList.push(step);
                  }
                });
            }
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications.");
          }
        );
      }
    },
    onAddNotification() {
      this.isNotification = true;
    },
    onEditNotification(payload) {
      const { questionId, type, answer, thresholdMax, thresholdMin, notificationId, stepName, contacts } = payload;
      this.notificationPayload = {
        questionId: questionId || "default",
        stepName: stepName || "Select a step",
        notificationId: notificationId,
        type: type || "default",
        answer: answer || "default",
        thresholdMin: thresholdMin || "",
        thresholdMax: thresholdMax || "",
        contacts: contacts
      };
      this.isNotification = true;
      this.isEditMode = true;
      this.currentQuestionId = questionId;
    },
    onSaveNotification(payload) {
      if (this.siteFacing == "true" || this.siteFacing == true) {
        this.$api.addActivityNotificationFactV2(this.studyId, this.formId, payload).then(
          () => {
            this.onClose();
            this.getAllNotification();
            this.$forceUpdate();
            this.$toastr.success("Notifications saved successfully");
          },
          error => {
            this.onClose();
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error to save the notifications.");
          }
        );
      } else if (this.siteFacing == "false" || this.siteFacing == false) {
        this.formData.questions.forEach(obj => {
          if (obj.id == this.currentQuestionId) {
            if (obj.hasOwnProperty("notifications")) {
              delete obj["notifications"];
              this.currentQuestionId = null;
            }
          }
        });
        payload.contacts.filter(objContactId => {
          this.siteTeamList.forEach(objSite => {
            if (objSite.id == objContactId.id) {
              objContactId.firstName = objSite.firstName;
              objContactId.email = objSite.email;
              objContactId.lastName = objSite.lastName;
              objContactId.phoneNumber = objSite.phoneNumber;
              objContactId.status = objSite.status;
              objContactId.workNumber = objSite.workNumber;
            }
          });
          return objContactId;
        });
        payload.contacts.filter(objContactId => {
          this.studyTeam.forEach(objSite => {
            if (objSite.id == objContactId.id) {
              objContactId.firstName = objSite.firstName;
              objContactId.email = objSite.email;
              objContactId.lastName = objSite.lastName;
              objContactId.phoneNumber = objSite.phoneNumber;
              objContactId.status = objSite.status;
              objContactId.workNumber = objSite.workNumber;
            }
          });
          return objContactId;
        });
        this.formData.questions.forEach((obj, index) => {
          if (obj.id == payload.questionId) {
            payload.triggeringResponse = payload.type;
            payload.stepType = obj.type;
            payload.stepName = obj.body;
            if (this.isEditMode) {
              payload.notificationId = this.notificationPayload.notificationId;
            } else {
              payload.notificationId = uuidv4();
            }
            this.formData.questions[index].notifications = [];
            this.formData.questions[index].notifications.push(payload);
          }
        });
        this.surveyId = this.formId;
        this.$api.saveParticipantResource(this.studyId, this.surveyId, this.formData).then(
          () => {
            this.onClose();
            this.getAllNotification();
            this.$forceUpdate();
            this.$toastr.success("Notifications saved successfully");
          },
          error => {
            this.onClose();
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error to save the notifications.");
          }
        );
      }
    },
    onDeleteNotification(notification) {
      swal
        .fire({
          title: "Are you sure you want to delete this notification?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4a4a4a",
          cancelButtonColor: "#1e8fe1",
          confirmButtonText: "No",
          cancelButtonText: "Yes"
        })
        .then(({ dismiss }) => {
          if ((dismiss === "cancel" && this.siteFacing == true) || this.siteFacing == "true") {
            this.$api.deleteEDCNotificationFactV2(this.studyId, notification.questionId, notification.notificationId, this.formId).then(
              () => {
                this.getAllNotification();
              },
              error => {
                this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while deleting activity.");
              }
            );
          } else if ((dismiss === "cancel" && this.siteFacing == false) || this.siteFacing == "false") {
            this.formData.questions.find((obj, index) => {
              if (obj.id == notification.questionId) {
                delete this.formData.questions[index].notifications;
              }
            });
            this.surveyId = this.formId;
            this.$api.saveParticipantResource(this.studyId, this.surveyId, this.formData).then(
              () => {
                this.getAllNotification();
              },
              error => {
                this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while deleting activity.");
              }
            );
          }
        });
    }
  }
};
</script>

<style lang="scss">
.continue-btn-modal:disabled {
  opacity: 0.65 !important;
  cursor: not-allowed;
}
.th-notification-settings-main-container {
  .th-notification-select-user-dropdown {
    font-size: 14px;
    font-weight: normal;
    color: #666669;
    display: flex;
    align-items: flex-end;
  }
  .toggle-email-label {
    font-size: 12px;
    font-weight: bold;
    color: #b0bac9;
  }
  .setting-btn-text {
    position: relative;
    right: 5px;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    color: #b0bac9;
  }
  .switch-option {
    float: left;
    width: 100%;
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 20px;
    float: left;
    margin-right: 10px;
  }
  .switch input {
    display: none;
  }
  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px solid #ccc;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 2px;
    bottom: 1px;
    background-color: #ccc;
  }
  input:checked + .slider {
    border: 2px solid #48bf7a;
  }
  input:checked + .slider:before {
    content: "";
    background-color: #48bf7a;
  }
  input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }
  input:checked + .slider:before {
    /*content: '✓';*/
    position: absolute;
    color: #2ecc71;
    text-align: center;
    font-size: 20px;
    -webkit-transform: translateX(14px);
    -ms-transform: translateX(14px);
    transform: translateX(14px);
  }
  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }
  .slider.round:before {
    border-radius: 50%;
  }
  .filds_section {
    border-radius: 8px;
    padding: 0 10px 10px;
    background-color: #ffffff;
    border: solid 1px #d3dfe4;
    min-height: 150px;
  }
  #notificationModal .close-dialog-icon {
    position: absolute;
    right: 10px;
    top: 5px;
    cursor: pointer;
  }
}
</style>
